import { Component, Prop, Host, h, State } from '@stencil/core';
import _ from 'lodash'
import 'bootstrap/dist/js/bootstrap.bundle.min.js'
import sanitizeHtml from 'sanitize-html';
import '../header-component/header-component';
import '../loader-component/loader-component'


/**
 
#### Sample screen shot
![image info](https://infonet.nyp.org/webc/PublishingImages/accordionfreetext_component.PNG)

#### Content Type
nypwebc_ct_freetext_accordion

 */


@Component({
  tag: 'accordionfreetext-component',
  styleUrl: 'accordionfreetext-component.css',
  //shadow: true,
  scoped: true
})
export class AccordionfreetextComponent {



  /**
   *Required - Unique ID.
   */
  @Prop() componentid: string = "comp-id";

  /**
  *Required - List Name.
  */
  @Prop() listname: string = "ListName";

  /**
  *Required - Relative to the root site. no trailing slash. for ex: /hr/pm
  */
  @Prop() webpath: string = "/";

  /**
  *Required - if header attribute is true
  */
  @Prop() sectiontitle: string = "Section Title";

  /**
  *Required - if header attribute is true
  */
  @Prop() titleiconurl: string = "";

  /**
 *Optional - To show/hide header. default is true
 */
  @Prop() header: boolean = true;

  /**
 *Optional - vertical scroll bar
 */
  @Prop() verticalscroll: boolean = false;

  /**
 *Optional - vertical scroll bar height
 */
  @Prop() verticalscrollheight: number = 200;

  /**
 *Optional - To show see All link
 */
  @Prop() seeall: boolean = false;
  /**
 *Optional - see All Url
 */
  @Prop() seeallurl: string;

  /**
*Optional - see All link Title
*/
  @Prop() seealltitle: string = "See All";

  /**
    *Optional - number of items to retrieve
    */
  @Prop() count: number = 100;

  /**
*Optional - header background color
*/
  @Prop() headerbgcolor: string = "white"

  /**
  *Optional -header text color
  */
  @Prop() headertextcolor: string = "black"
  /**
  *Optional -header border bottom css
  */
  @Prop() headerborderbottom: string = "1px solid #CE2127"


  /**
  *Optional - headertext location
*/
  @Prop() headerlocation: string = "top";

  /**
  *Optional - expand all by default 
  */
  @Prop() expandall: boolean = false

 /**
 *Optional - Expand /collapse all toggle
 */@Prop() exptoggle: boolean = false

  /**
 *Optional - Expand the first item. default is false
 */@Prop() expandfirst: boolean = false



  /**
*Optional - is it SP Online site
*/
  @Prop() online: boolean = false;

  /**
   *Required - site url if its sp online site
   */
  @Prop() siteurl: string = "";

  @State() items: []
  @State() isLoading: boolean = true
  @State() expandallclick: boolean
  @State() expandbuttonclick: boolean =false



  componentDidLoad() {
    // const siteUrl = (window as any)._spPageContextInfo.siteAbsoluteUrl;

    // let siteUrl: string = "";

    // if (this.online) {
    //   siteUrl = this.siteurl + this.webpath
    // }
    // else {
    //   siteUrl = (window as any)._spPageContextInfo.siteAbsoluteUrl + this.webpath;
    // }

    
    let siteUrl: string = "";
    if ((window as any)._spPageContextInfo != null) {
      siteUrl = (window as any)._spPageContextInfo.siteAbsoluteUrl + this.webpath;
    }
    else {
      let domain = new URL(window.location.href)
      siteUrl = domain.origin + this.webpath
    }
    
    const filter = "nypwebc_Active eq 1";

    return fetch(siteUrl + "/_api/web/lists/getbytitle('" + this.listname + "')/items?$select=ID,Title,nypwebc_ItemOrder,nypwebc_Section,nypwebc_Body,nypwebc_Description&$filter=" + filter + "&$orderby=nypwebc_ItemOrder&$top=" + this.count, { headers: { "Accept": "application/json; odata=verbose" } })
      .then(response => response.json())
      .then(data => {
        this.items = data.d.results;
        this.isLoading = false;
        this.expandallclick = this.expandall
      });
  }
  handleClick = () => {
    this.expandallclick = !this.expandallclick
    this.expandbuttonclick=true;
  }
  getContents = () => {
    const contentsArray = []
    const expToggleArray = []

    if (this.exptoggle) {
      expToggleArray.push(
        <div class="row">
          <div class="col-md-12">
            <a class="float-end" target= "_blank"  data-interception="off" onClick={this.handleClick} style={{ paddingRight: "10px", paddingTop: "5px" }}  >
              <img src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAZCAYAAADE6YVjAAAABmJLR0QA/wD/AP+gvaeTAAABQ0lEQVRIie3Vv0oDQRAG8J8KmkaSdAqmsdEEH0PwHax8AiEvIIhWeQ8b64BFKh9AUEgTECtLFcFGg6DF7eHlXO9PSOkHA7dz38w37O7M8o8aWIr4trCaWb/ipUbONXwUETbxhQlGwc5qCHRxh0YRqYNxIPZqJBf4leI6GFYI2EFzHoGsSJroFnsR3gAHFXhgObd+w034nuAQFwUV9nAZeOPC8kuQHmYr4xugb76z+xMts9d9ILmmx9gP1ozEgZWKIu+59RRPWMd2sHs8V8y3eMQ6PsUujnK+K1zXFSnark/JNj1IOvhEMl5GmQJbfm/lXEgbrS858BTt4O8uSqAnab5Bwf8UpwpuWh75To6JxHhDyeQoRazCZkhYxq8kUmvYReLGZSKNOQTO/bw9E8l7tJElxPqk9GXLoR0sxRSPNeL/MYtvYfFDhGCJYBYAAAAASUVORK5CYII=" alt="Expand/collapse all" />
            </a>
          </div>
        </div>
      )
    }

    let accordionidhash = '#' + this.componentid + '-' + 'accordion'

    let expandbody = "accordion-collapse collapse"
    let expandheader = "accordion-button collapsed shadow-none"
    if (this.expandallclick) {
      expandbody = "accordion-collapse show"
      expandheader = "accordion-button shadow-none"
    }



    let campuses = _.uniq(_.map(this.items, 'nypwebc_Section'))
    let header = "";
    let firstItemIndex=0
    campuses.forEach((element, index) => {

      let expandbody = "accordion-collapse collapse"
      let expandheader = "accordion-button collapsed shadow-none"
  
      if (this.expandallclick) {
        expandbody = "accordion-collapse show"
        expandheader = "accordion-button shadow-none"
      }
      if (element === 'Header') {

        let descItems = _.filter(this.items, function (n: any) {
          return n.nypwebc_Section === element;
        });

        header = <p class="raw-html-style"  style={{ margin: "10px 25px 10px 25px" }} innerHTML={descItems[0].nypwebc_Description}> </p>
        firstItemIndex=1
      }
      else {

        if (index === firstItemIndex && this.expandfirst && !this.expandbuttonclick )
        {
          expandbody = "accordion-collapse show"
          expandheader = "accordion-button shadow-none"
        }
        

        let idheading = this.componentid + 'heading' + index
        let idcollapsehash = '#' + this.componentid + 'collapse' + index
        let idcollapse = this.componentid + 'collapse' + index
        const contentsHeaderArray = []
        contentsHeaderArray.push(

          <h2 class="accordion-header" id={idheading}>
            <button class={expandheader} style={{ fontSize: "16px" }} type="button" data-bs-toggle="collapse" data-bs-target={idcollapsehash} aria-expanded="false" aria-controls={idcollapse}>
              {element}
            </button>
          </h2>
        )

        let campusItems = _.filter(this.items, function (n: any) {
          return n.nypwebc_Section === element;
        });
        const listitems = []
        for (let i = 0; i < campusItems.length; i++) {

          // const html = "<strong>hello world</strong>";
          // console.log(sanitizeHtml(campusItems[i].Description));
          // const clean = sanitizeHtml(campusItems[i].Description, {
          //   allowedTags: ['b', 'i', 'em', 'strong', 'a', 'span'],
          //   allowedAttributes: {
          //     'a': ['href']
          //   }
          // });

          var string = campusItems[i].nypwebc_Body;
          var parser = new DOMParser();
          var domNode = parser.parseFromString(string, "text/html");
          const img = domNode.querySelectorAll("img");
          const tables = domNode.querySelectorAll("table");
          for (let i = 0; i < img.length; i++) {
            img[i].classList.add("sc-accordionfreetext-component", "img-fluid", "rounded");
          }


          for (let i = 0; i < tables.length; i++) {
            tables[i].classList.add("sc-about-component", "table");
          }
  
          for (let i = 0; i < tables.length; i++) {
            let parent = tables[i].parentNode;
            let divWrapper = document.createElement("div");
            divWrapper.classList.add("sc-about-component", "table-responsive", "tableborder")
            parent.replaceChild(divWrapper, tables[i]);
            divWrapper.appendChild(tables[i]);
          }

          listitems.push(
            <div class="accordion-body">
              <div class="raw-html-style" innerHTML={domNode.body.innerHTML} ></div>
            </div>

          )
        }
        contentsArray.push(
          <div class="accordion-item">
            {contentsHeaderArray}
            <div id={idcollapse} class={expandbody} aria-labelledby={idheading} data-bs-parent={accordionidhash} >
              {listitems}
            </div>
          </div>
        )
      }
    });
    if (header && this.headerlocation === "top") {
      contentsArray.unshift(header)
    }
    else if (header && this.headerlocation === "bottom") {
      contentsArray.push(header)
    }
    if (this.exptoggle) {
      contentsArray.unshift(expToggleArray)
    }
    return contentsArray

  }

  render() {


    let style = {}
    let styleWithHeader = {}
    let parentstyle = {}
    if (this.verticalscroll) {
      style = {
        maxHeight: this.verticalscrollheight + "px",
        overflowY: "auto",
        overflowX: "hidden"

      }
      styleWithHeader = {
        maxHeight: this.verticalscrollheight + "px",
        overflowY: "auto",
        overflowX: "hidden"
      }

      parentstyle = {
        minHeight: (this.verticalscrollheight + 20) + "px",
        backgroundColor: "white",
        borderBottomRightRadius: "5px",
        borderBottomLeftRadius: "5px",
        paddingBottom: "10px"
      }
    }
    else {
      style = {
      }
      parentstyle = {
        backgroundColor: "white",
        borderBottomRightRadius: "5px",
        borderBottomLeftRadius: "5px",
        paddingBottom: "10px"
      }
    }

    let accordionid = this.componentid + '-' + 'accordion'
    return (

      this.isLoading ? <loader-component /> :

        this.header && this.items.length > 0 ?
          <div>
            <header-component sectiontitle={this.sectiontitle} titleiconurl={this.titleiconurl} seeall={this.seeall} seealltitle={this.seealltitle} seeallurl={this.seeallurl} headerbgcolor={this.headerbgcolor} headertextcolor={this.headertextcolor} headerborderbottom={this.headerborderbottom} />
            <div class="row gx-0" style={parentstyle}>
              <div style={styleWithHeader}>
                <div class="accordion accordion-flush" id={accordionid}>
                  {this.getContents()}
                </div>
              </div>
            </div>
          </div>
          :
          <div class="row gx-0" style={parentstyle}>
            <div style={style}>
              <div class="accordion accordion-flush" id={accordionid}>
                {this.getContents()}
              </div>
            </div>
          </div>
    )
  }


}
